module.exports = __webpack_public_path__ + "images/assets/190b03ea0f6736a78ab2dd4f516e1587.svg";